export default "__VITE_ASSET__DcpJwo1I__"